import Index from '@tunnel-components/@pages/lapi-tmd/cameras/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/cameras/index.ts